import styled from 'styled-components'

export const RSSFeedLinkContainer = styled.div(
  ({ theme }) => `
  margin-top: ${theme.spacing.large};

  svg {
    width: 5.4rem;
    height: ${theme.spacing.large};
  }
`
)
